interface PromoVisualProps {
  /** The modal's header is a short, wide banner — a single flattened asset with the gradient,
   * title text and logos already baked in. The Integrations page card is tall/narrow and shows
   * the person/product photo prominently, with the title rendered separately outside the card. */
  variant?: "banner" | "card";
}

export const PromoVisual = ({ variant = "card" }: PromoVisualProps) => {
  const isBanner = variant === "banner";
  const src = isBanner ? "/TikTok_integrations-bg-modal.png" : "/TikTok_integrations-bg-page.png";

  if (isBanner) {
    return <img src={src} alt="" className="absolute inset-0 w-full object-cover" />;
  }

  return <img src={src} alt="" className="absolute -left-4 top-4 w-[200%] rounded-sm object-cover max-w-none" />;
};
